import { ChangeEvent, FormEvent, RefObject, ComponentProps, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import styles from '@components/Search/components/ControlledSearchBox/ControlledSearchBox.styles';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
export type PropsType = ComponentProps<'div'> & {
  inputRef: RefObject<HTMLInputElement>;
  onChange(event: ChangeEvent): void;
  onSubmit(): void;
  placeholder: string;
  value: string;
};
const ControlledSearchBox = ({
  inputRef,
  onChange,
  onSubmit,
  placeholder,
  value
}: PropsType) => {
  const {
    closeSearch
  } = layoutUiState;
  useEffect(() => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
  }, [inputRef]);
  const handleCloseSearch = () => {
    closeSearch();
  };
  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (onSubmit) {
      onSubmit();
    }
    if (inputRef.current) {
      inputRef.current.blur();
    }
  }
  function handleReset(event: FormEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }
  return <div sx={styles.searchBoxContainer} data-cy="SearchBox">
      <div sx={styles.searchBoxWrapper}>
        <Icon size={['29px', '29px', '29px', '29px', '36px']} icon="Search" />
        <div sx={styles.fromContainer}>
          <form action="" noValidate onSubmit={handleSubmit} onReset={handleReset}>
            <input sx={styles.searchBox} type="search" autoFocus autoComplete="off" autoCorrect="off" autoCapitalize="off" placeholder={placeholder} spellCheck={false} maxLength={512} ref={inputRef} value={value} onChange={onChange} />
          </form>
        </div>
        <Button variant="iconOnly" onClick={handleCloseSearch} cy="SearchModalCloseButton">
          <Icon size={['16px', '16px', '21px', '21px', '26px']} icon="Close2" />
        </Button>
      </div>
    </div>;
};
export default observer(ControlledSearchBox);